<template>
  <div class="card">
    <Tabs :tabs="tabs" />
    <router-view></router-view>
  </div>
</template>
<script>
import Tabs from "../../../components/Tabs.vue";
export default {
  data: () => ({
    loading: false,
    tabs: ["Server Variables", "Generic Rules"],
  }),
  components: { Tabs },
};
</script>
<style lang="scss">
.handle,
.handleBlocks {
  cursor: move;
}
.card-body.disabled {
  pointer-events: none;
  opacity: 0.7;
}
.flaticon-edit,
.flaticon-close {
  font-weight: bolder;
  font-size: 20px !important;
  color: #2196f3 !important;
}
.varNameTypes {
  .input-group-text {
    padding: 0 !important;
    background-color: #fff !important;
  }
  .custom-select,
  input[type="text"] {
    height: 40px;
  }
  .btn.btn-outline-primary {
    color: #111;
    background-color: transparent;
    border-color: #f3f6f9;
    border-radius: 0;
  }

  .btn.btn-outline-primary:not(:disabled):not(.disabled):active:not(.btn-text),
  .btn.btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn.btn-outline-primary.dropdown-toggle,
  .show .btn.btn-outline-primary.btn-dropdown {
    background-color: #f3f6f9;
    border-color: #f3f6f9;
    color: #111;
  }
}
.btn.btn-info {
  background-color: #469598 !important;
  border-color: #469598 !important;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: "" !important;
  display: none;
}
.custom-input-label {
  position: absolute;
  z-index: 0;
  color: #fff;
  width: 95px;
  display: flex;
  cursor: pointer;
  background-color: #469598 !important;
  border-color: #469598 !important;
  height: 100%;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
}
.custom-file {
  width: 95px;
  opacity: 0;
  cursor: pointer;
  .custom-file-label {
    background-color: #469598 !important;
    border-color: #469598 !important;
    .form-file-text {
      opacity: 0;
      cursor: pointer;
      pointer-events: all !important;
    }
  }
}
</style>
